import { createSignal } from '@funtech-int/rival';
import { useSignal } from '@funtech-int/rival-react';

const isReadyToPlayVar = createSignal(false);

export const useIsReadyToPlay = () => useSignal(isReadyToPlayVar);

export const setReadyToPlay = (isReadyToPlay: boolean) => isReadyToPlayVar.set(isReadyToPlay);
